import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { getAssetById } from '../../mutations/queries';
import { QueryKeys } from '../../react-query/QueryKeys';
import { toast } from 'react-toastify';
import Loading from '../../components/Loading';
import NoAsset from '../../components/NoAssets';
import Header from './components/Header';
import CompanyDetails from './components/CompanyDetails';
import Overview from './components/Overview';
import Contact from './components/Contact';

const ShowAsset = () => {
  const { id } = useParams();

  const {
    data: asset = {},
    isLoading,
    isError,
  } = useQuery([QueryKeys.ASSETS, id], () => {
    if (id) {
      return getAssetById(id);
    }
  });

  if (isError) {
    toast.error('Something went wrong');
  }

  if (isLoading) {
    return <Loading />;
  }

  if (asset?.message === 'Asset not found') {
    return <NoAsset />;
  }

  return (
    <div>
      <Header asset={asset} />
      <CompanyDetails asset={asset} />
      <Overview asset={asset} />
      <Contact asset={asset} />
    </div>
  );
};

export default ShowAsset;
